import React from 'react';
import '../styles/PrivacyPolicy.css';
import Seo from '../components/Seo';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <Seo
        title="Privacy Policy | Chartmaxx AI"
        description="Read the Chartmaxx AI privacy policy for the AI-powered chart analysis app for stocks, crypto, forex, commodities, and indices."
        path="/privacy-policy"
      />
      <h2>Privacy Policy</h2>
      <p>
        <strong>Last Updated:</strong> 21 January 2025
      </p>
      <p>
        <strong>Introduction</strong>
        <br />
        Welcome to Chartmaxx.AI! Your chartmaxxing app. Your privacy is important to us. This Privacy Policy explains how we collect, use, and safeguard your information when you use our AI-powered chart analysis app, specifically designed to analyze charts related to stocks, cryptocurrency, and forex markets.
      </p>
      <p>
        <strong>Information We Collect</strong>
      </p>
      <p>
        <strong>Uploaded Images:</strong> When you upload charts for analysis, we process and store the images temporarily to perform the analysis. These images are deleted after processing and are not stored permanently.
      </p>
      <p>
        <strong>Device and Usage Data:</strong> We may collect data such as device type, operating system, app usage statistics, and error logs to improve our service.
      </p>
      <p>
        <strong>Optional Account Information:</strong> If you create an account, we may collect your name, email address, and preferences for personalization purposes.
      </p>
      <p>
        <strong>How We Use Your Information</strong>
      </p>
      <p>To analyze the uploaded charts and provide accurate results.</p>
      <p>To improve app performance, security, and functionality.</p>
      <p>To communicate with you regarding updates, support, and feedback.</p>
      <p>To comply with legal obligations and resolve disputes.</p>
      <p>
        <strong>Data Retention</strong>
        <br />
        Uploaded images are processed and deleted immediately after analysis. We do not store any user-uploaded content on our servers. Other personal information (if provided) is retained only as long as necessary to fulfill the purposes outlined in this policy.
      </p>
      <p>
        <strong>Data Sharing</strong>
        <br />
        We do not sell, rent, or share your personal data with third parties except:
      </p>
      <p>When required by law or government regulations.</p>
      <p>With trusted service providers who help us operate the app, under strict confidentiality agreements.</p>
      <p>
        <strong>Security</strong>
        <br />
        We take appropriate technical and organizational measures to protect your data from unauthorized access, alteration, disclosure, or destruction. However, no system is 100% secure, and we cannot guarantee absolute security.
      </p>
      <p>
        <strong>Your Rights</strong>
      </p>
      <p>You have the right to access, update, or delete your personal information.</p>
      <p>You can request information about how your data is used and processed.</p>
      <p>You may withdraw consent for data processing where applicable.</p>
      <p>
        <strong>Third-Party Links</strong>
        <br />
        Our app may contain links to external websites or services. We are not responsible for the privacy practices of these third-party platforms and encourage you to review their privacy policies.
      </p>
      <p>
        <strong>Changes to This Privacy Policy</strong>
        <br />
        We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The updated policy will be posted here with the "Last Updated" date.
      </p>
      <p>
        <strong>Contact Us</strong>
        <br />
        If you have any questions or concerns about this Privacy Policy, please contact us at info@chartmaxxapp.com.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
